
    import { Vue, Prop, Component, Watch } from "vue-property-decorator";
    import VueCircle from 'vue2-circle-progress'
    import AlertPopUp from "@/views/shared/AlertPopUp.vue";
    import ErrorNotification from "@/views/shared/ErrorNotification.vue";
    import router from '@/router';
    import { namespace } from "vuex-class";
    import { PendingShift, Event } from '@/models';
    import moment from "moment";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { useAppInsights } from '../../store/modules/AppInsights'
    import CommitmentSubmitPopup from "@/views/shared/CommitmentSubmitPopup.vue";
    import TrainingVideos from '../shared/TrainingVideos.vue';

    const schedule = namespace("schedule");
    const profile = namespace("profile");

    @Component({
        components: {
            VueCircle,
            Loading,
            AlertPopUp,
            ErrorNotification,
            CommitmentSubmitPopup,
            TrainingVideos
        },
    })
    export default class CommitmentLevel extends Vue {
        @schedule.State
        public userSchedules!: any;

        @schedule.State
        public defaultSelfSchedules!: any;

        @profile.State
        public profileData!: any;

        @schedule.State
        public selfScheduleShiftDetails: any;

        @profile.State
        appInsightEventData!: any;

        $refs!: {
            totalProgress;
            week1Progress;
            week2Progress;
            week3Progress;
            week4Progress;
            week5Progress;
            week6Progress;
            weekendProgress;
        };

        totalProgress: number = 0;
        week1Progress: number = 0;
        week2Progress: number = 0;
        week3Progress: number = 0;
        week4Progress: number = 0;
        week5Progress: number = 0;
        week6Progress: number = 0;
        weekendProgress: number = 0;
        totalHours: number = 0;
        totalGuranteedHours: number = 0;
        weeklyGuranteedHours: number = 0;
        weeklyOTHours: number = 0;
        isSubmitBtnEnabled: boolean = true;
        weeklyCommitmentCompleted: boolean = false;
        weekendShiftComitmentCompleted: boolean = false;
        icon_ExClp: string = "expand_less";
        isWeeklyProgressVisible: boolean = true;
        totalProgressExceedsCommitment: boolean = false;
        showCommitmentExceededAlert: boolean = false;
        isAlertModalVisible: boolean = false;
        alertMsgValue: string = '';
        errorMsg: string = '';
        errorType: string = '';
        showErrorMsg: boolean = false;
        hasSelfScheduleNeedsInPrimaryDept: boolean =  false;
        isOvertimeIndicatorVisible: boolean = false;
        applySelfSchedulingBtnText: string = "Create Schedule Preferences"
        isApplySelfSchedulingBtnEnabled: boolean = true;
        pendingShiftList: PendingShift[] = [];
        isLoading: boolean = false;
        deptShifts: any = [];
        defaultSelfSchedulingEvents: any[] = [];
        loaderColor: string = "#0085ca";
        isCommitmentSubmitModalVisible: boolean = false; 
        scheduleToCommitment: boolean = false;
        weekendCommitment: boolean = false;
        scheduleBeyondcommitment: boolean = false;
        isSuccess: boolean = false;
        isCommitmentValid: boolean = true;
        @Prop()
        public objCommitmentSubmit!: any;

        @Prop()
        public isSidePanelOpen!: any;

        @Watch('objCommitmentSubmit', { deep: true })
        onCSChanges(newValue: any, oldValue: any) {
            if (oldValue != undefined) {
                if (newValue.week1Hours != oldValue.week1Hours ||
                    newValue.week2Hours != oldValue.week2Hours ||
                    newValue.week3Hours != oldValue.week3Hours ||
                    newValue.week4Hours != oldValue.week4Hours ||
                    (this.objCommitmentSubmit.weeksInSchedule == 6 && (newValue.week5Hours != oldValue.week5Hours || newValue.week6Hours != oldValue.week6Hours)) ||
                    newValue.countWSC != oldValue.countWSC ||
                    newValue.scheduleStatus != oldValue.scheduleStatus ||
                    ((newValue.pendingShiftList.filter((p) => p.isCommitment).length == 0 && newValue.pendingShifts > 0) ||
                    (oldValue.pendingShiftList.filter((p) => p.isCommitment).length == 0 && oldValue.pendingShifts > 0))) {
                    this.getCommitmentDetails();
                }
            }
        }

        mounted() {
            this.getCommitmentDetails();
        }

        getCommitmentDetails() {
            if (this.objCommitmentSubmit != undefined && this.objCommitmentSubmit.guranteedHours != undefined) {
                this.hasSelfScheduleNeedsInPrimaryDept = this.objCommitmentSubmit.hasSelfScheduleNeedsInPrimaryDept;
                this.isOvertimeIndicatorVisible = false;
                if(this.objCommitmentSubmit.defaultSelfScheduleState != "" && this.objCommitmentSubmit.defaultSelfScheduleState != undefined){
                    this.applySelfSchedulingBtnText = this.objCommitmentSubmit.defaultSelfScheduleState;
                }
                this.weeklyGuranteedHours = this.objCommitmentSubmit.guranteedHours;
                this.weeklyOTHours = this.objCommitmentSubmit.otHours;
                this.totalGuranteedHours = (this.objCommitmentSubmit.guranteedHours * this.objCommitmentSubmit.weeksInSchedule);
                var totalGuranteedHours5_6Week = (this.objCommitmentSubmit.weeksInSchedule == 6 ? (this.objCommitmentSubmit.week5Hours + this.objCommitmentSubmit.week6Hours) : 0);
                this.totalHours = Math.round(this.objCommitmentSubmit.week1Hours + this.objCommitmentSubmit.week2Hours +
                    this.objCommitmentSubmit.week3Hours + this.objCommitmentSubmit.week4Hours + totalGuranteedHours5_6Week);
                this.totalProgress = ((this.totalHours.valueOf() / this.totalGuranteedHours.valueOf()) * 100);
                this.totalProgressExceedsCommitment = (this.totalProgress > 100 ? true : false);
                this.totalProgress = (this.totalProgress > 100 ? 100 : this.totalProgress);

                this.objCommitmentSubmit.week1Hours = Math.round(this.objCommitmentSubmit.week1Hours);
                this.objCommitmentSubmit.week2Hours = Math.round(this.objCommitmentSubmit.week2Hours);
                this.objCommitmentSubmit.week3Hours = Math.round(this.objCommitmentSubmit.week3Hours);
                this.objCommitmentSubmit.week4Hours = Math.round(this.objCommitmentSubmit.week4Hours);

                if (this.objCommitmentSubmit.weeksInSchedule == 6) {
                    this.objCommitmentSubmit.week5Hours = Math.round(this.objCommitmentSubmit.week5Hours);
                    this.objCommitmentSubmit.week6Hours = Math.round(this.objCommitmentSubmit.week6Hours);
                }
                
                this.week1Progress = ((this.objCommitmentSubmit.week1Hours.valueOf() / this.weeklyGuranteedHours.valueOf()) * 100); 

                let week1OTProgress = ((this.objCommitmentSubmit.week1Hours.valueOf() / this.weeklyOTHours.valueOf()) * 100);
                if(this.weeklyOTHours > 0 && week1OTProgress > 100){
                    this.$refs.week1Progress.updateFill("#992902");
                    this.isOvertimeIndicatorVisible = true;
                }
                else if (this.week1Progress > 100) {
                   this.$refs.week1Progress.updateFill("#ffc844");
                }
                else {
                    this.$refs.week1Progress.updateFill("#007fbe");
                }
                this.week1Progress = (this.week1Progress > 100 ? 100 : this.week1Progress);
                this.$refs.week1Progress.updateProgress(this.week1Progress);

                this.week2Progress = ((this.objCommitmentSubmit.week2Hours.valueOf() / this.weeklyGuranteedHours.valueOf()) * 100);
                
                let week2OTProgress = ((this.objCommitmentSubmit.week2Hours.valueOf() / this.weeklyOTHours.valueOf()) * 100);
                if(this.weeklyOTHours > 0 && week2OTProgress > 100){
                    this.$refs.week2Progress.updateFill("#992902");
                    this.isOvertimeIndicatorVisible = true;
                }
                else if (this.week2Progress > 100) {
                    this.$refs.week2Progress.updateFill("#ffc844");
                }
                else {
                    this.$refs.week2Progress.updateFill("#007fbe");
                }
                this.week2Progress = (this.week2Progress > 100 ? 100 : this.week2Progress);
                this.$refs.week2Progress.updateProgress(this.week2Progress);

                this.week3Progress = ((this.objCommitmentSubmit.week3Hours.valueOf() / this.weeklyGuranteedHours.valueOf()) * 100);
                
                let week3OTProgress = ((this.objCommitmentSubmit.week3Hours.valueOf() / this.weeklyOTHours.valueOf()) * 100);
                if(this.weeklyOTHours > 0 && week3OTProgress > 100){
                    this.$refs.week3Progress.updateFill("#992902");
                    this.isOvertimeIndicatorVisible = true;
                }
                else if (this.week3Progress > 100) {
                    this.$refs.week3Progress.updateFill("#ffc844");
                }
                else {
                    this.$refs.week3Progress.updateFill("#007fbe");
                }
                this.week3Progress = (this.week3Progress > 100 ? 100 : this.week3Progress);
                this.$refs.week3Progress.updateProgress(this.week3Progress);

                this.week4Progress = ((this.objCommitmentSubmit.week4Hours.valueOf() / this.weeklyGuranteedHours.valueOf()) * 100);
                
                let week4OTProgress = ((this.objCommitmentSubmit.week4Hours.valueOf() / this.weeklyOTHours.valueOf()) * 100);
                if(this.weeklyOTHours > 0 && week4OTProgress > 100){
                    this.$refs.week4Progress.updateFill("#992902");
                    this.isOvertimeIndicatorVisible = true;
                }
                else if (this.week4Progress > 100) {
                    this.$refs.week4Progress.updateFill("#ffc844");
                }
                else {
                    this.$refs.week4Progress.updateFill("#007fbe");
                }
                this.week4Progress = (this.week4Progress > 100 ? 100 : this.week4Progress);
                this.$refs.week4Progress.updateProgress(this.week4Progress);

                if (this.objCommitmentSubmit.weeksInSchedule == 6) {
                    this.week5Progress = ((this.objCommitmentSubmit.week5Hours.valueOf() / this.weeklyGuranteedHours.valueOf()) * 100);

                    let week5OTProgress = ((this.objCommitmentSubmit.week5Hours.valueOf() / this.weeklyOTHours.valueOf()) * 100);
                    if (this.$refs.week5Progress != undefined) {
                        if(this.weeklyOTHours > 0 && week5OTProgress > 100){
                            this.$refs.week5Progress.updateFill("#992902");
                            this.isOvertimeIndicatorVisible = true;
                        }
                        else if (this.week5Progress > 100) {
                            this.$refs.week5Progress.updateFill("#ffc844");
                        }
                        else {
                            this.$refs.week5Progress.updateFill("#007fbe");
                        }
                    }
                    this.week5Progress = (this.week5Progress > 100 ? 100 : this.week5Progress);
                    if (this.$refs.week5Progress != undefined) {
                        this.$refs.week5Progress.updateProgress(this.week5Progress);
                    }

                    this.week6Progress = ((this.objCommitmentSubmit.week6Hours.valueOf() / this.weeklyGuranteedHours.valueOf()) * 100);

                    let week6OTProgress = ((this.objCommitmentSubmit.week6Hours.valueOf() / this.weeklyOTHours.valueOf()) * 100);
                    if (this.$refs.week6Progress != undefined) {
                        if(this.weeklyOTHours > 0 && week6OTProgress > 100){
                            this.$refs.week6Progress.updateFill("#992902");
                            this.isOvertimeIndicatorVisible = true;
                        }
                        else if (this.week6Progress > 100) {
                            this.$refs.week6Progress.updateFill("#ffc844");
                        }
                        else {
                            this.$refs.week6Progress.updateFill("#007fbe");
                        }
                    }
                    this.week6Progress = (this.week6Progress > 100 ? 100 : this.week6Progress);
                    if (this.$refs.week6Progress != undefined) {
                        this.$refs.week6Progress.updateProgress(this.week6Progress);
                    }
                }
                else {
                    var divWeek5 = document.getElementById('divWeek5') as HTMLElement;
                    divWeek5.style.display = "none";

                    var divWeek6 = document.getElementById('divWeek6') as HTMLElement;
                    divWeek6.style.display = "none";
                }

                this.weekendProgress = ((this.objCommitmentSubmit.weekendHours / (this.objCommitmentSubmit.reqCountWSC * 12).valueOf()) * 100);
                if (this.$refs.weekendProgress != undefined) {
                    if (this.weekendProgress > 100) {
                        this.$refs.weekendProgress.updateFill("#ffc844");
                    }
                    else {
                        this.$refs.weekendProgress.updateFill("#007fbe");
                    }
                }
                this.weekendProgress = (this.weekendProgress > 100 ? 100 : this.weekendProgress);
                if (this.$refs.weekendProgress != undefined) {
                    this.$refs.weekendProgress.updateProgress(this.weekendProgress);
                }
                const { selfScheduleToCommitment } = this.objCommitmentSubmit;
                if (this.objCommitmentSubmit.scheduleStatus == 'PLAN SHEET' && selfScheduleToCommitment) {
                    this.validateCommitment();
                }
            }
        }

        validateCommitment() {
            const { selfScheduleToCommitment, selfSchedulePastCommitment, limitSelfScheduleToTarget, week1Hours, week2Hours, week3Hours, week4Hours, week5Hours, week6Hours, displayWSC, countWSC, reqCountWSC } = this.objCommitmentSubmit;
            this.showCommitmentExceededAlert = false;
            this.isSubmitBtnEnabled =  true;
            this.scheduleToCommitment = false;
            this.weekendCommitment = false;
            this.scheduleBeyondcommitment = false;
            this.isCommitmentSubmitModalVisible = false;
            this.isSuccess = false;
            var currSchedule = this.userSchedules.find(x => x.id == this.objCommitmentSubmit.scheduleId);
            var scheduleStartDate =  currSchedule.startDate;
            var scheduleendDate =  currSchedule.endDate;
            var employeeEndDate = this.profileData.employeeEndDate;
            
            if (this.objCommitmentSubmit.employeeType != "PRN") {
                if (this.objCommitmentSubmit.weeksInSchedule == 6) {
                   if (((week1Hours + week2Hours) == 2* this.weeklyGuranteedHours) &&
                        ((week3Hours + week4Hours) == 2* this.weeklyGuranteedHours) &&
                        ((week5Hours + week6Hours) == 2* this.weeklyGuranteedHours)
                       ) {
                        this.weeklyCommitmentCompleted = true;
                    } else  if (((week1Hours + week2Hours) >= 2* this.weeklyGuranteedHours) &&
                        ((week3Hours + week4Hours) >= 2* this.weeklyGuranteedHours) &&
                        ((week5Hours + week6Hours) >= 2* this.weeklyGuranteedHours)
                       ) {
                        this.weeklyCommitmentCompleted = true;
                        if(!selfSchedulePastCommitment) {
                            this.showCommitmentExceededAlert = true;
                        }
                    }
                    else {
                        this.weeklyCommitmentCompleted = false;
                    }
                }
                else {
                    if (((week1Hours + week2Hours) == 2* this.weeklyGuranteedHours) &&
                        ((week3Hours + week4Hours) == 2* this.weeklyGuranteedHours)
                       ) {
                        this.weeklyCommitmentCompleted = true;
                    } else if (((week1Hours + week2Hours) >= 2* this.weeklyGuranteedHours) &&
                        ((week3Hours + week4Hours) >= 2* this.weeklyGuranteedHours)
                       ) {
                        this.weeklyCommitmentCompleted = true;
                        if(!selfSchedulePastCommitment) {
                            this.showCommitmentExceededAlert = true;
                        }
                    }
                    else {
                        this.weeklyCommitmentCompleted = false;
                    }
                }
            }
            else //-- "PRN" Employee Type
            {
                if (this.objCommitmentSubmit.weeksInSchedule == 6) {
                    if (selfSchedulePastCommitment &&
                        ((week1Hours + week2Hours) >= 2 * this.weeklyGuranteedHours &&
                            (week3Hours + week4Hours) >= 2 * this.weeklyGuranteedHours &&
                            (week5Hours + week6Hours) >= 2 * this.weeklyGuranteedHours
                           )) {
                        this.weeklyCommitmentCompleted = true;
                    }
                    else if (!selfSchedulePastCommitment &&
                        ((week1Hours + week2Hours) >= 2 * this.weeklyGuranteedHours && (week1Hours + week2Hours) <= 2 * this.objCommitmentSubmit.maxSelfScheduleHours) &&
                        ((week3Hours + week4Hours) >= 2 * this.weeklyGuranteedHours && (week3Hours + week4Hours) <= 2 * this.objCommitmentSubmit.maxSelfScheduleHours) &&

                        ((week5Hours + week6Hours) >= 2 * this.weeklyGuranteedHours && (week5Hours + week6Hours) <= 2 * this.objCommitmentSubmit.maxSelfScheduleHours)
                       ) {
                        this.weeklyCommitmentCompleted = true;
                    }
                    else if (!selfSchedulePastCommitment &&
                        ((week1Hours + week2Hours) >= 2 * this.weeklyGuranteedHours && (week1Hours + week2Hours) >= 2 * this.objCommitmentSubmit.maxSelfScheduleHours) &&
                        ((week3Hours + week4Hours) >= 2 * this.weeklyGuranteedHours && (week3Hours + week4Hours) >= 2 * this.objCommitmentSubmit.maxSelfScheduleHours) &&

                        ((week5Hours + week6Hours) >= 2 * this.weeklyGuranteedHours && (week5Hours + week6Hours) <= 2 * this.objCommitmentSubmit.maxSelfScheduleHours)
                       ) {
                        this.weeklyCommitmentCompleted = true;
                        this.showCommitmentExceededAlert = true;
                    }
                    else {
                        this.weeklyCommitmentCompleted = false;
                    }
                }
                else {
                    if (selfSchedulePastCommitment &&
                        ((week1Hours + week2Hours) >= 2 * this.weeklyGuranteedHours &&
                        (week3Hours + week4Hours) >= 2 * this.weeklyGuranteedHours )) {
                        this.weeklyCommitmentCompleted = true;
                    }
                    else if (!selfSchedulePastCommitment &&
                        ((week1Hours + week2Hours) >= 2 * this.weeklyGuranteedHours && (week1Hours + week2Hours) <= 2 * this.objCommitmentSubmit.maxSelfScheduleHours) &&

                        ((week3Hours + week4Hours) >= 2 * this.weeklyGuranteedHours && (week3Hours + week4Hours) <= 2 * this.objCommitmentSubmit.maxSelfScheduleHours)
                        ) {
                        this.weeklyCommitmentCompleted = true;
                    }
                     else if (!selfSchedulePastCommitment &&
                        ((week1Hours + week2Hours) >= 2 * this.weeklyGuranteedHours && (week1Hours + week2Hours) >= 2 * this.objCommitmentSubmit.maxSelfScheduleHours) &&

                        ((week3Hours + week4Hours) >= 2 * this.weeklyGuranteedHours && (week3Hours + week4Hours) >= 2 * this.objCommitmentSubmit.maxSelfScheduleHours)
                        ) {
                        this.weeklyCommitmentCompleted = true;
                        this.showCommitmentExceededAlert = true;
                    }
                    else {
                        this.weeklyCommitmentCompleted = false;
                    }
                }
            }

            if (displayWSC) {
                if (countWSC >= reqCountWSC) {
                    this.weekendShiftComitmentCompleted = true;
                }
                else {
                    this.weekendShiftComitmentCompleted = false;
                    this.weekendCommitment = true;
                }
            }
            else {
                this.weekendShiftComitmentCompleted = true;
            }
            if(this.weeklyCommitmentCompleted == true && this.weekendShiftComitmentCompleted == true && this.objCommitmentSubmit.pendingShifts > 0)
            {
                this.isCommitmentValid = true;
            }
            else if(!this.hasSelfScheduleNeedsInPrimaryDept && selfScheduleToCommitment && limitSelfScheduleToTarget)  
            {
                this.isCommitmentValid = true;
            }  
            else if(!this.weekendShiftComitmentCompleted && this.weeklyCommitmentCompleted == true && this.hasSelfScheduleNeedsInPrimaryDept && selfScheduleToCommitment && limitSelfScheduleToTarget && displayWSC)  
            {
                this.isCommitmentValid = true;
            } 
            //  else if(!this.weekendShiftComitmentCompleted && !this.hasSelfScheduleNeedsInPrimaryDept && selfScheduleToCommitment && limitSelfScheduleToTarget && displayWSC)  
            // {
            //     this.isSubmitBtnEnabled = true;
            // }  
            else { 
                if (this.profileData?.employeeType?.includes('PRN') && this.totalHours >= this.totalGuranteedHours) {
                    this.isCommitmentValid = true
                } else {

                    this.isCommitmentValid = false;
                }
            }
            if(this.objCommitmentSubmit.pendingShifts <= 0)
            {
                this.isSubmitBtnEnabled = false;
            }
            if(selfScheduleToCommitment && !this.weeklyCommitmentCompleted)  
            {                
                 this.scheduleToCommitment = true;
            }      
            if(this.showCommitmentExceededAlert)  
            {
                this.scheduleBeyondcommitment = true;
            } 
            if(employeeEndDate > scheduleStartDate && employeeEndDate < scheduleendDate){
                this.showCommitmentExceededAlert = false;
                this.isCommitmentValid = true;
            } 
        }

        async submitCommitmentDetails() {
            if(this.showCommitmentExceededAlert || !this.isCommitmentValid ){
                this.isCommitmentSubmitModalVisible = true;
                this.isSuccess = false;
                return;
            }

            this.isSubmitBtnEnabled = false;

            await this.$store.dispatch('schedule/SubmitCommitmentDetails', this.objCommitmentSubmit.scheduleId)
                .then((res: any) => {
                    //this.$emit("showSuccessModalCS");
                    this.isCommitmentSubmitModalVisible = true;
                    this.isSuccess = true;
                })
                .catch((err: any) => {
                    if (err) {                              
                                this.showErrorMsg = true;
                                this.errorType = "error";
                                this.errorMsg = err.request.responseText ? err.request.responseText : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                                this.isSubmitBtnEnabled = true;
                              }
                });

                this.$emit("refreshCalendarView");
        }

        toggleExpansion() {
            this.icon_ExClp = (this.isWeeklyProgressVisible == true ? "expand_more" : "expand_less");
            this.isWeeklyProgressVisible = !this.isWeeklyProgressVisible;
        }

        async applySelfSchedulePreferences(){
            this.isApplySelfSchedulingBtnEnabled = false;
            if(this.applySelfSchedulingBtnText == 'Create Schedule Preferences'){
                router.push("/profile");
                localStorage.setItem("isSelfScheduleDefaultRedirect", 'true');
            }
            else if(this.applySelfSchedulingBtnText == 'Apply My Preferences'){
                await this.$store.dispatch('schedule/getDefaultSelfSchedules',  { username: this.profileData.username })
                .then((res: any) => {
                    //Apply Validation
                    this.checkSelfScheduleDefaultVaildation();
                })
                .catch((err: any) => {
                    if (err) {
                                console.log(err);
                                this.showErrorMsg = true;
                                this.errorType = "error";
                                this.errorMsg = err.request.responseText ? err.request.responseText : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                                this.isApplySelfSchedulingBtnEnabled = true;
                              }
                });
            }
        }

        async checkSelfScheduleDefaultVaildation(){
            //load current schedule
            var currSchedule = this.userSchedules.find(x => x.id == this.objCommitmentSubmit.scheduleId);
            var scheduleStartDate =  currSchedule.startDate;

            //load department shift
            const payload = { date: scheduleStartDate, departmentIds: this.profileData.deptId, username: this.profileData.username };

            var errorMessage = '';
            await this.$store
                .dispatch("schedule/GetSelfScheduleNeedsDetails", payload)
                .then((data) => {
                    this.deptShifts = this.removeDuplicatesFromArrayByProperty(this.selfScheduleShiftDetails.filter(x => x.departmentId == this.profileData.deptId), 'shiftCode');

                    this.deptShifts.forEach((shift: any) => {
                        let startTime, endTime;
                        startTime = this.formatTime(this.addMinutes(shift.startTime, shift.offset));
                        endTime = this.formatTime(this.addMinutes(this.addMinutes(shift.endTime, shift.offset), shift.breakMinutes));

                        if (shift.shiftDescription.trim().toUpperCase() == shift.shiftCode.trim().toUpperCase()) {
                            shift.shiftDescription = shift.shiftDescription + " " + startTime.toUpperCase() + " - " + endTime.toUpperCase();
                        }
                    });

                    var defaultShifts = this.defaultSelfSchedules.defaultShifts;
                    if(defaultShifts != null && defaultShifts.length > 0){
                        for (var k = 0; k < defaultShifts.length; k++) {
                            var eventDate = moment(scheduleStartDate).add(defaultShifts[k].dayOfSchedule - 1, 'days').format("YYYY-MM-DD");
                            
                            const selectedDeptShift = this.deptShifts.find(x => x.departmentShiftId == defaultShifts[k].departmentShiftId && x.departmentId == defaultShifts[k].departmentId);
                            defaultShifts[k].productiveType = selectedDeptShift.productiveType;
                            //Home Department Need Validation
                            var lstNeedEvent: Event[] = currSchedule.events.filter(x => x.type == "Need" && moment(x.date).format("YYYY-MM-DD") == eventDate
                                                    && (
                                                        (x.hasEventSelfScheduleNeedsInPrimaryDept && parseInt(x.status.split(' ')[0]) > 0) ||
                                                        (!x.hasEventSelfScheduleNeedsInPrimaryDept && x.status == "Add Shift")
                                                    ));
                            var isaddDefaultEvent = true;
                            if(lstNeedEvent != null && lstNeedEvent?.length > 0){
                                //Pending and Scheduled Event Validation
                                var lstEvents: Event[] = currSchedule.events.filter(x => (x.type == "Pending" || x.type == "Assignment") && moment(x.date).format("YYYY-MM-DD")  == eventDate);
                                if (lstEvents != null && lstEvents?.length > 0) {
                                    for (var j = 0; j < lstEvents.length; j++) {
                                        const selectedDeptShift = this.deptShifts.find(x => x.shiftCode == lstEvents[j].shiftCode);
                                        //----selectedDeptShift == undefined ---> when shiftcode is PTO or other requested events turned as scheduled assignments
                                        if (selectedDeptShift == undefined || ((selectedDeptShift.startTime < defaultShifts[k].endTime) && (defaultShifts[k].startTime < selectedDeptShift.endTime))) {
                                            isaddDefaultEvent = false;
                                            if(errorMessage == ''){
                                                errorMessage = 'Some of your preferred shifts could not be created. See below for details'
                                                errorMessage += '<ul class="ulList">'
                                            }
                                            errorMessage += '<li>' + moment(eventDate).format('MMM DD, YYYY') + ": Overlaps with previously scheduled shift" + '</li>';
                                        }
                                    }
                                }

                                //Unavailability Event Validation
                                var unavailabilityEvent: Event[] = currSchedule.events.filter(x => x.type == "Unavailability" && moment(x.date).format("YYYY-MM-DD")  == eventDate);
                                if (unavailabilityEvent != null && unavailabilityEvent?.length > 0) {
                                    isaddDefaultEvent = false;
                                    if(errorMessage == ''){
                                        errorMessage = 'Some of your preferred shifts could not be created. See below for details'
                                        errorMessage += '<ul class="ulList">'
                                    }
                                    errorMessage += '<li>' + moment(eventDate).format('MMM DD, YYYY') + ": Overlaps approved time off" + '</li>';
                                }
                            }
                            else{
                                isaddDefaultEvent = false;
                                if(errorMessage == ''){
                                    errorMessage = 'Some of your preferred shifts could not be created. See below for details'
                                    errorMessage += '<ul class="ulList">'
                                }
                                errorMessage += '<li>' + moment(eventDate).format('MMM DD, YYYY') + ": There are no available shifts remaining on this date in your home department." + '</li>';
                            }
                            
                            if(isaddDefaultEvent){
                                this.defaultSelfSchedulingEvents.push(defaultShifts[k]);
                            }
                        }
                    }

                    if(errorMessage != ''){
                        errorMessage += '</ul>'
                        errorMessage += '<b class="boldTxt">Note</b>: You can manually adjust your shift requests throughout the self-scheduling period by clicking dates and choosing shift details.'
                        let flag = false;
                        let msgValue = errorMessage;
                        this.$emit("showNotificationErrorModalCS", {
                            successFlag: flag,
                            msgValue: msgValue
                        });
                    }

                    //Save events to Cosmos or FS DB
                    if(this.defaultSelfSchedulingEvents.length > 0){
                        const { selfScheduleToCommitment } = this.objCommitmentSubmit;
                        if (selfScheduleToCommitment) {
                            this.SaveNeedsDetails(this.defaultSelfSchedulingEvents);
                        }
                        else {
                            this.SaveSelfScheduleAsAssignment(this.defaultSelfSchedulingEvents);
                        }
                    }
                    else{
                        this.isApplySelfSchedulingBtnEnabled = true;
                    }
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
        }

        removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        formatTime(t: Date): string {
            return moment(t).format("h:mm a");
        }

        addMinutes(date, minutes) {
            return moment(date).add(minutes, 'm').toDate();
        }

        async SaveNeedsDetails(defaultsShift: any[]) {
            var currSchedule = this.userSchedules.find(x => x.id == this.objCommitmentSubmit.scheduleId);
            var scheduleStartDate =  currSchedule.startDate;  
                var item = 0;
                for (var k = 0; k < defaultsShift.length; k++) {
                        var ShiftDetails = {
                            id: this.getGuidforPendingShift(),
                            username: this.profileData.username,
                            date: moment(scheduleStartDate).add(defaultsShift[k].dayOfSchedule - 1, 'days').format("YYYY-MM-DD"),
                            startTime: defaultsShift[k].startTime,
                            endTime: defaultsShift[k].endTime,
                            actualStartTime: defaultsShift[k].actualStartTime,
                            actualEndTime: defaultsShift[k].actualEndTime,
                            departmentShiftId: defaultsShift[k].departmentShiftId,
                            scheduleId: this.objCommitmentSubmit.scheduleId,
                            tenantId: this.defaultSelfSchedules.tenantId,
                            departmentId: defaultsShift[k].departmentId,
                            staffId: this.defaultSelfSchedules.staffId,
                            skillId: defaultsShift[k].skillId,
                            shiftCode: defaultsShift[k].shiftCode,
                            shiftDescription: defaultsShift[k].shiftDescription,
                            skill: defaultsShift[k].skill,
                            facilityName: defaultsShift[k].facilityName,
                            departmentName: defaultsShift[k].departmentName,
                            productiveType: defaultsShift[k].productiveType,
                            //shiftMembers: this.selfScheduleShiftMembers != undefined ? this.selfScheduleShiftMembers.shiftMembers : null
                        };
                        this.pendingShiftList[item] = JSON.parse(JSON.stringify(ShiftDetails));
                        item++;
                }

                this.isLoading = true;
                await this.$store.dispatch('schedule/SavePendingShiftDetails', this.pendingShiftList)
                    .then((res: any) => {
                        //showing message in MyScheduleView Screen
                        this.isLoading = false;
                        let flag = true;
                        let msgValue = `Your scheduling preferences have been applied. <br/> 
                                        Click <b class="boldTxt">Submit</b> to request this schedule. <br/> 
                                        <b class="boldTxt">Note</b>: You can make edits to your schedule as needed throughout the self-scheduling period.`
                        this.$emit("showNotificationSuccessModalCS", {
                            successFlag: flag,
                            msgValue: msgValue
                        });
                        this.isApplySelfSchedulingBtnEnabled = true;
                        this.UpdateDefaultSelfScheduleAppliedStatus(currSchedule.id);
                        this.$emit("refreshCalendarView");
                        this.applySelfSchedulingBtnText = 'Preferences Applied';
                        this.defaultSelfSchedulingEvents = [];
                        useAppInsights().trackEvent({name:'ApplyDefaultSchedule',properties: 
                            JSON.parse(JSON.stringify(this.appInsightEventData))
                        });
                    })
                    .catch((err: any) => {
                        if (err) {
                            this.isLoading = false;
                            console.log(err);
                            let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                            this.showErrorMsg = true;
                            this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                            this.defaultSelfSchedulingEvents = [];
                        }
                    });
        }

        async SaveSelfScheduleAsAssignment(defaultsShift: any[]) {
            var currSchedule = this.userSchedules.find(x => x.id == this.objCommitmentSubmit.scheduleId);
            var scheduleStartDate =  currSchedule.startDate;  
            var lstAssignments: any[] = [];
            let item = 0;
            for (var i = 0; i < defaultsShift.length; i++) {
                    let ShiftDetails = {
                        //scheduleId: this.currentEvent.assignmentId,
                        tenantId: this.defaultSelfSchedules.tenantId,
                        departmentShiftId: defaultsShift[i].departmentShiftId,
                        departmentId: defaultsShift[i].departmentId,
                        staffId: this.defaultSelfSchedules.staffId,
                        skillLevelId: defaultsShift[i].skillId,
                        date: moment(scheduleStartDate).add(defaultsShift[i].dayOfSchedule - 1, 'days').format("YYYY-MM-DD"),
                        startTime: defaultsShift[i].startTime,
                        productiveType: defaultsShift[i].productiveType,
                        endTime: defaultsShift[i].endTime,
                        scheduleId: this.objCommitmentSubmit.scheduleId,
                        //shiftMembers: this.selfScheduleShiftMembers != undefined ? this.selfScheduleShiftMembers.shiftMembers : null
                    };
                    lstAssignments[item] = JSON.parse(JSON.stringify(ShiftDetails));
                    item++;
            }

            this.isLoading = true;
            await this.$store.dispatch('schedule/SaveSelfScheduleAsAssignment', lstAssignments)
                .then((res: any) => {
                    //showing message in MyScheduleView Screen
                    this.isLoading = false;
                    let flag = true;
                    let msgValue = `Your scheduling preferences have been applied. <br/> 
                                    <b class="boldTxt">Note</b>: You can make edits to your schedule as needed throughout the self-scheduling period.`
                    this.$emit("showNotificationSuccessModalCS", {
                            successFlag: flag,
                            msgValue: msgValue
                        });
                    this.isApplySelfSchedulingBtnEnabled = true;
                    this.UpdateDefaultSelfScheduleAppliedStatus(currSchedule.id);
                    this.$emit("refreshCalendarView");
                    this.applySelfSchedulingBtnText = 'Preferences Applied';
                    this.defaultSelfSchedulingEvents = [];
                    useAppInsights().trackEvent({name:'ApplyDefaultSchedule',properties: 
                        JSON.parse(JSON.stringify(this.appInsightEventData))
                    });
                })
                .catch((err: any) => {
                    if (err) {
                        this.isLoading = false;
                        console.log(err);
                        let parseResponse = err.request.responseText != "" ? JSON.parse(err.request.responseText) : err.request.responseText;
                        this.showErrorMsg = true;
                        this.errorMsg = (parseResponse.result != null || parseResponse.result != undefined) ? JSON.parse(parseResponse.result).Message : "An error has occurred. Please try again. If the error persists, contact Facility Scheduler support.";
                        this.defaultSelfSchedulingEvents = [];
                    }
                });
        }

        async UpdateDefaultSelfScheduleAppliedStatus(scheduleId) {
            this.isLoading = true;
            await this.$store.dispatch('schedule/UpdateDefaultSelfScheduleAppliedStatus', scheduleId)
                .then((res: any) => {
                    this.isLoading = false;
                })
                .catch((err: any) => {
                    if (err) {
                        this.isLoading = false;
                    }
                });
        }

        getGuidforPendingShift() {
            var uuidValue = "", k, randomValue;
            for (k = 0; k < 32; k++) {
                randomValue = Math.random() * 16 | 0;
                if (k == 8 || k == 12 || k == 16 || k == 20) {
                    uuidValue += "-"
                }
                uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
            }
            return uuidValue;
        }
    }
